import React, { FC } from 'react';
import ReactMarkdown, { Options } from 'react-markdown';
import rehypeExternalLinks from 'rehype-external-links';
import remarkGfm from 'remark-gfm';

type TMarkdownCoreProps = {
  markdown: string;
} & Options;

const MarkdownCore: FC<TMarkdownCoreProps> = (props) => {
  const { markdown, remarkPlugins, rehypePlugins, ...rest } = props;

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm, ...(remarkPlugins ?? [])]}
      rehypePlugins={[
        [
          rehypeExternalLinks,
          {
            target: '_blank',
            rel: ['noopener', 'noreferrer', 'nofollow'],
          },
        ],
        ...(rehypePlugins ?? []),
      ]}
      {...rest}
    >
      {markdown}
    </ReactMarkdown>
  );
};

export default MarkdownCore;
